export const MODEL_UNKNOWN_ID = 1
export const MODEL_OTHER_ID = 2
export const MODEL_SEARCH_MAX_LENGTH = 100
export const MODEL_SUGGESTION_MIN_LENGTH = 1
export const MODEL_SUGGESTION_MAX_LENGTH = 100
